"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _isInteger2 = _interopRequireDefault(require("lodash/isInteger"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Avatar = _interopRequireDefault(require("../../Clients/Avatar"));
var _Count = _interopRequireDefault(require("../../Common/Count"));
var _Name = _interopRequireDefault(require("../../Clients/Name"));
var _Selector = _interopRequireDefault(require("../../Common/Selector"));
var _excluded = ["managers", "value"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var avatarPropTypes = _Avatar["default"].propTypes;
var avatarUrlType = avatarPropTypes.url,
  nameType = avatarPropTypes.name;
var CLASS_NAME_PREFIX = _Selector["default"].CLASS_NAME_PREFIX;
var PLACEHOLDER = 'Выбрать ответственного';
var StyledAvatar = (0, _styledComponents["default"])(_Avatar["default"]).withConfig({
  displayName: "TicketFilterByManager__StyledAvatar",
  componentId: "sc-1e6lx3z-0"
})([""]);
var StyledName = (0, _styledComponents["default"])(_Name["default"]).withConfig({
  displayName: "TicketFilterByManager__StyledName",
  componentId: "sc-1e6lx3z-1"
})(["font-size:14px;font-weight:300;"]);
var StyledCount = (0, _styledComponents["default"])(_Count["default"]).withConfig({
  displayName: "TicketFilterByManager__StyledCount",
  componentId: "sc-1e6lx3z-2"
})(["margin-left:auto;"]);
var StyledMangerBase = _styledComponents["default"].div.withConfig({
  displayName: "TicketFilterByManager__StyledMangerBase",
  componentId: "sc-1e6lx3z-3"
})(["align-items:center;display:flex;"]);
var StyledOption = (0, _styledComponents["default"])(StyledMangerBase).withConfig({
  displayName: "TicketFilterByManager__StyledOption",
  componentId: "sc-1e6lx3z-4"
})(["align-items:center;display:flex;", "{height:26px;width:26px;}", "{color:#4d4d4d;margin-left:10px;}"], StyledAvatar, StyledName);
var StyledValue = (0, _styledComponents["default"])(StyledMangerBase).withConfig({
  displayName: "TicketFilterByManager__StyledValue",
  componentId: "sc-1e6lx3z-5"
})(["", "{height:18px;width:18px;}", "{margin-left:6px;}"], StyledAvatar, StyledName);
var StyledSelector = (0, _styledComponents["default"])(_Selector["default"]).withConfig({
  displayName: "TicketFilterByManager__StyledSelector",
  componentId: "sc-1e6lx3z-6"
})(["border:1px solid #e6e9ee;box-sizing:border-box;border-radius:4px;padding:0 3px;.", "__multi-value{background:#f5f3f2;border:none;}.", "__multi-value__label{padding-left:4px !important;color:#4d4d4d;}", "__placeholder{color:#919499;}"], CLASS_NAME_PREFIX, CLASS_NAME_PREFIX, CLASS_NAME_PREFIX);
var TicketFilterByManager = /*#__PURE__*/function (_React$PureComponent) {
  function TicketFilterByManager(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, TicketFilterByManager);
    _this = _callSuper(this, TicketFilterByManager, [props]);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleRef = _this.handleRef.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(TicketFilterByManager, _React$PureComponent);
  return (0, _createClass2["default"])(TicketFilterByManager, [{
    key: "handleChange",
    value: function handleChange(value) {
      var _this$props = this.props,
        name = _this$props.name,
        onChange = _this$props.onChange;
      var formatedValue = Array.isArray(value) ? value.map(function (v) {
        return v.value;
      }) : null;
      this.el.name = name;
      this.el.value = formatedValue;
      var event = new CustomEvent('change', {
        bubbles: true
      });
      this.el.dispatchEvent(event);
      onChange(event);
    }
  }, {
    key: "handleRef",
    value: function handleRef(ref) {
      this.el = _reactDom["default"].findDOMNode(ref);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        managers = _this$props2.managers,
        value = _this$props2.value,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      if ((0, _isEmpty2["default"])(managers)) {
        return null;
      }
      var formatedValue = null;
      if (Array.isArray(value)) {
        formatedValue = value.map(function (v) {
          return (0, _find2["default"])(managers, {
            value: v
          });
        });
      }
      return /*#__PURE__*/_react["default"].createElement(StyledSelector, (0, _extends2["default"])({}, props, {
        components: {
          MultiValueLabel: TicketFilterByManager.getMultiValueLabel
        },
        isMulti: true,
        isSearchable: true,
        filterOption: TicketFilterByManager.customFilter,
        onChange: this.handleChange,
        options: managers,
        placeholder: PLACEHOLDER,
        ref: this.handleRef,
        value: formatedValue
      }), function (_ref) {
        var data = _ref.data;
        var avatarUrl = data.avatarUrl,
          name = data.name,
          unreadAmount = data.unreadAmount;
        var isValidCount = (0, _isInteger2["default"])(unreadAmount) && unreadAmount > 0;
        return /*#__PURE__*/_react["default"].createElement(StyledOption, null, /*#__PURE__*/_react["default"].createElement(StyledAvatar, {
          name: name,
          url: avatarUrl
        }), name && /*#__PURE__*/_react["default"].createElement(StyledName, {
          name: name
        }), isValidCount && /*#__PURE__*/_react["default"].createElement(StyledCount, {
          value: unreadAmount
        }));
      });
    }
  }], [{
    key: "getMultiValueLabel",
    value: function getMultiValueLabel(prop) {
      var data = prop.data,
        innerProps = prop.innerProps;
      var avatarUrl = data.avatarUrl,
        name = data.name;
      return /*#__PURE__*/_react["default"].createElement(StyledValue, innerProps, /*#__PURE__*/_react["default"].createElement(StyledAvatar, {
        name: name,
        url: avatarUrl
      }), /*#__PURE__*/_react["default"].createElement(StyledName, {
        name: name
      }));
    }
  }, {
    key: "customFilter",
    value: function customFilter(_ref2, searchText) {
      var data = _ref2.data;
      var name = data.name;
      var formattedName = name && name.toLowerCase() || '';
      var formattedQuery = searchText && searchText.toLowerCase();
      var isMatched = formattedName.includes(formattedQuery);
      return isMatched;
    }
  }]);
}(_react["default"].PureComponent);
var valueProp = _propTypes["default"].string;
TicketFilterByManager.propTypes = {
  className: _propTypes["default"].string,
  managers: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    avatarUrl: avatarUrlType,
    label: _propTypes["default"].string.isRequired,
    name: nameType,
    unreadAmount: _propTypes["default"].number,
    value: valueProp.isRequired
  }).isRequired),
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].arrayOf(valueProp.isRequired)
};
TicketFilterByManager.defaultProps = {
  className: '',
  managers: null,
  name: '',
  onChange: Function.prototype,
  value: null
};
var _default = exports["default"] = TicketFilterByManager;